<!-- Mobile Layout (hidden on desktop) -->
<div class="md:hidden">
  <div class="p-4">
    <!-- Mobile Header (always visible) -->
    <mat-card
      class="mat-elevation-z0 fixed top-4 z-20 mb-4 h-fit w-[calc(100%-32px)] items-center gap-x-4 rounded-2xl shadow-[2px_4px_12px_0px_#717E8A33]"
    >
      <div class="flex w-full items-center gap-x-4">
        <img
          alt="Mol Limo"
          src="../../../assets/figures/logo.svg"
          class="h-8"
        />
        <div class="flex-1"></div>
        <button mat-icon-button (click)="toggleMobileMenu()">
          <mat-icon>{{ isMobileMenuOpen ? "close" : "menu" }}</mat-icon>
        </button>
      </div>
      <div
        class="mobile-menu-expandable -ml-4 w-[calc(100%+32px)]"
        [class.expanded]="isMobileMenuOpen"
      >
        <mat-card
          class="mat-elevation-z2 relative overflow-hidden rounded-none"
        >
          <!-- Navigation Items -->
          <nav>
            <!-- Követelés kezelés -->
            <button
              *ngIf="
                currentPermissions.includes(AdminPermission.CLAIMS_MANAGEMENT)
              "
              mat-button
              class="mobile-nav-item"
              [class.mobile-nav-item-active]="
                router.url.startsWith('/claim-management')
              "
              (click)="navigateAndClose(['/claim-management'])"
            >
              <mat-icon>account_balance</mat-icon>
              <span class="ml-2">Követelés kezelés</span>
            </button>

            <!-- Feketelista -->
            <button
              *ngIf="
                currentPermissions.includes(
                  AdminPermission.BLACKLIST_MANAGEMENT
                )
              "
              mat-button
              class="mobile-nav-item"
              [class.mobile-nav-item-active]="
                router.url.startsWith('/blacklist')
              "
              (click)="navigateAndClose(['/blacklist'])"
            >
              <mat-icon>list</mat-icon>
              <span class="ml-2">Feketelista</span>
            </button>

            <!-- Adminkezelés -->
            <button
              *ngIf="
                currentPermissions.includes(AdminPermission.ADMIN_MANAGEMENT)
              "
              mat-button
              class="mobile-nav-item"
              [class.mobile-nav-item-active]="router.url.startsWith('/admins')"
              (click)="navigateAndClose(['/admins'])"
            >
              <mat-icon>person</mat-icon>
              <span class="ml-2">Adminkezelés</span>
            </button>

            <!-- RAC Management with Expandable Submenu -->
            <div class="mobile-nav-group">
              <button
                mat-button
                class="mobile-nav-item"
                [class.mobile-nav-item-active]="isRacMenuActive()"
                (click)="toggleRacSubMenu()"
              >
                <mat-icon>directions_car</mat-icon>
                <span class="ml-2">RAC Management</span>
                <mat-icon class="ml-auto">
                  {{ isRacSubMenuExpanded ? "expand_less" : "expand_more" }}
                </mat-icon>
              </button>

              <!-- RAC Submenu -->
              <div
                class="mobile-submenu"
                [class.expanded]="isRacSubMenuExpanded"
              >
                <button
                  mat-button
                  class="mobile-submenu-item"
                  [class.mobile-submenu-item-active]="
                    router.url.startsWith('/copy-management')
                  "
                  (click)="navigateAndClose(['/copy-management'])"
                >
                  <span>Copy management</span>
                </button>
                <button
                  mat-button
                  class="mobile-submenu-item"
                  [class.mobile-submenu-item-active]="
                    router.url.startsWith('/station-configurator')
                  "
                  (click)="navigateAndClose(['/station-configurator'])"
                >
                  <span>Station configurator</span>
                </button>
                <button
                  mat-button
                  class="mobile-submenu-item"
                  [class.mobile-submenu-item-active]="
                    router.url.startsWith('/manage-cars')
                  "
                  (click)="navigateAndClose(['/manage-cars'])"
                >
                  <span>Manage cars</span>
                </button>
                <button
                  mat-button
                  class="mobile-submenu-item"
                  [class.mobile-submenu-item-active]="
                    router.url.startsWith('/booking-management')
                  "
                  (click)="navigateAndClose(['/booking-management'])"
                >
                  <span>Booking management</span>
                </button>
              </div>
            </div>
          </nav>

          <!-- User Info Section -->
          <div class="border-t border-light-gray p-4">
            <p class="text-sm">
              {{ (authService.profile$ | async)?.name ?? "Ismeretlen" }}
            </p>
          </div>
          <div class="border-t border-light-gray pt-4">
            <button
              mat-button
              color="primary"
              (click)="onLogout()"
              class="text-[#004c44]"
            >
              <mat-icon>logout</mat-icon>
              Kijelentkezés
            </button>
          </div>
        </mat-card>
      </div>
    </mat-card>

  </div>

  <!-- Backdrop overlay when menu is open -->
  <div
    class="mobile-menu-backdrop"
    [class.visible]="isMobileMenuOpen"
    (click)="closeMobileMenu()"
  ></div>
</div>

<!-- Desktop Layout -->
<div class="hidden p-4 md:block">
  <!-- Desktop Header -->
  <mat-card
    class="sticky top-4 z-20 flex h-20 items-center gap-x-8 rounded-2xl px-12 shadow-[2px_4px_12px_0px_#717E8A33] xl:px-32"
  >
    <img alt="Mol Limo" src="../../../assets/figures/logo.svg" />
    <div class="flex items-center gap-x-2">
      <button
        *ngIf="currentPermissions.includes(AdminPermission.CLAIMS_MANAGEMENT)"
        mat-button
        color="primary"
        [routerLink]="['/claim-management']"
        [routerLinkActive]="'topic-btn-active'"
        class="rounded-xl py-1 px-4 text-base transition-shadow"
      >
        <mat-icon color="primary" aria-label="List icon"
          >account_balance</mat-icon
        >
        Követelés kezelés
      </button>
      <button
        *ngIf="
          currentPermissions.includes(AdminPermission.BLACKLIST_MANAGEMENT)
        "
        mat-button
        color="primary"
        [routerLink]="['/blacklist']"
        [routerLinkActive]="'topic-btn-active'"
        class="rounded-xl py-1 px-4 text-base transition-shadow"
      >
        <mat-icon color="primary" aria-label="List icon">list</mat-icon>
        Feketelista
      </button>
      <button
        *ngIf="currentPermissions.includes(AdminPermission.ADMIN_MANAGEMENT)"
        mat-button
        color="primary"
        [routerLink]="['/admins']"
        [routerLinkActive]="'topic-btn-active'"
        class="rounded-xl py-1 px-4 text-base transition-shadow"
      >
        <mat-icon color="primary" aria-label="User icon">person</mat-icon>
        Adminkezelés
      </button>
      <!-- RAC Management Dropdown -->
      <!-- TODO: Add permission check when RAC_MANAGEMENT is added to backend API -->
      <!-- *ngIf="currentPermissions.includes(AdminPermission.RAC_MANAGEMENT)" -->
      <button
        mat-button
        color="primary"
        [matMenuTriggerFor]="racMenu"
        class="rounded-xl py-1 px-4 text-base transition-shadow"
        #racMenuTrigger="matMenuTrigger"
        [class.topic-btn-active]="isRacMenuActive()"
      >
        <mat-icon color="primary" aria-label="Car icon"
          >directions_car</mat-icon
        >
        RAC Management
        <mat-icon color="primary" aria-label="Dropdown icon">
          {{ racMenuTrigger.menuOpen ? "expand_less" : "expand_more" }}
        </mat-icon>
      </button>

      <!-- RAC Management Dropdown Menu -->
      <mat-menu #racMenu="matMenu" class="rac-dropdown-menu">
        <button
          class="mat-mdc-menu-item"
          mat-menu-item
          [routerLink]="['/copy-management']"
          [routerLinkActive]="'active-menu-item'"
        >
          <mat-icon>edit</mat-icon>
          <span>Copy management</span>
        </button>
        <button
          class="mat-mdc-menu-item"
          mat-menu-item
          [routerLink]="['/station-configurator']"
          [routerLinkActive]="'active-menu-item'"
        >
          <mat-icon>edit</mat-icon>
          <span>Station configurator</span>
        </button>
        <button
          class="mat-mdc-menu-item"
          mat-menu-item
          [routerLink]="['/manage-cars']"
          [routerLinkActive]="'active-menu-item'"
        >
          <mat-icon>edit</mat-icon>
          <span>Manage cars</span>
        </button>
        <button
          class="mat-mdc-menu-item"
          mat-menu-item
          [routerLink]="['/booking-management']"
          [routerLinkActive]="'active-menu-item'"
        >
          <mat-icon>calendar_today</mat-icon>
          <span>Booking management</span>
        </button>
      </mat-menu>
    </div>
    <div class="hidden grow lg:flex"></div>
    <div class="flex items-center gap-x-10">
      <p>{{ (this.authService.profile$ | async)?.name ?? "Ismeretlen" }}</p>
      <button
        mat-button
        color="primary"
        (click)="onLogout()"
        class="rounded-xl py-1 px-4 text-base"
      >
        Kijelentkezés
        <mat-icon aria-label="List icon" color="primary">logout</mat-icon>
      </button>
    </div>
  </mat-card>
</div>

<!-- Shared Content (used by both mobile and desktop) -->
<div class="p-4">
  <router-outlet></router-outlet>
</div>
